import { render, staticRenderFns } from "./bookstore.view.vue?vue&type=template&id=6ff2275a&scoped=true&"
import script from "./bookstore.view.ts?vue&type=script&lang=ts&"
export * from "./bookstore.view.ts?vue&type=script&lang=ts&"
import style0 from "./bookstore.view.scss?vue&type=style&index=0&id=6ff2275a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff2275a",
  null
  
)

export default component.exports